import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CurrencyChangerService {

  // pull the raw JSON object you already store
  private initial = JSON.parse(
    sessionStorage.getItem('currency') || '{}' 
  );

  // seed the subject with that object
  private currencyUpdateSubject = new BehaviorSubject<any>(this.initial);

  headerUpdate$ = this.currencyUpdateSubject.asObservable();
  constructor() {
   }

   setCurrencyChange(data: any) {
     sessionStorage.setItem('sinL', 'true')
     sessionStorage.setItem('currency', JSON.stringify(data));
     this.currencyUpdateSubject.next(data);
  }
   getSelectedCurrency() {
     sessionStorage.setItem('sinL', 'false')
     const item: any = sessionStorage.getItem('currency')
     const data = JSON.parse(item)
     return data;
  }
  restartFreshSession() {
    window.addEventListener('unload', function(event) {
      sessionStorage.removeItem('sinL');
      sessionStorage.removeItem('currency');
    });
  }

    // helper for getting just the code string
    getCurrentCode(): string {
      return this.initial.currency || 'GBP';
    }

}
